import { IntlShape } from 'react-intl';
import { UnpaidInvoice } from '@futrli-sdk/predict';

export interface NormalizedUnpaidInvoice extends Omit<UnpaidInvoice, 'due_date' | 'issue_date'> {
  due_date: Date;
  issue_date: Date;
  expected_date: Date;
  converted_amount_due: number;
  converted_amount_total: number;
}

export enum InvoiceSummaryOption {
  Today = 'Today',
  ThisWeek = 'This week',
  ThisMonth = 'This month',
  ThisQuarter = 'This quarter',
  All = 'All'
}

export const translatedInvoicesSummaryOptions = (intl: IntlShape) => [
  { value: InvoiceSummaryOption.Today, text: intl.formatMessage({ id: 'common.today', defaultMessage: 'Today' }) },
  {
    value: InvoiceSummaryOption.ThisWeek,
    text: intl.formatMessage({ id: 'predict.this_week', defaultMessage: 'This week' })
  },
  {
    value: InvoiceSummaryOption.ThisMonth,
    text: intl.formatMessage({ id: 'reporting.period.this_month', defaultMessage: 'This month' })
  },
  {
    value: InvoiceSummaryOption.ThisQuarter,
    text: intl.formatMessage({ id: 'reporting.period.this_quarter', defaultMessage: 'This quarter' })
  },
  { value: InvoiceSummaryOption.All, text: intl.formatMessage({ id: 'predict.all', defaultMessage: 'All' }) }
];
